import AuthService from './auth.service';
import CategoryService from './category.service';
import ExerciseService from './exercise.service';
import PracticeService from './practice.service';
import SessionService from './session.service';
import SessionExerciseService from './session-exercise.service';
import HomeworkService from './homework.service';
import WarmUpService from './warmup.service';
import ScheduleService from './schedule.service';
import CouponService from './coupon.service';

interface Service {
  [key: string]: any;
}

const services: Service = {
  auth: AuthService,
  category: CategoryService,
  exercise: ExerciseService,
  practice: PracticeService,
  session: SessionService,
  sessionExercise: SessionExerciseService,
  homework: HomeworkService,
  warmup: WarmUpService,
  schedule: ScheduleService,
  coupon: CouponService
};

export const ServiceFactory = {
  get: (name: string) => services[name]
};
